import React, { useState } from 'react';
import {
  Card,
  ProgressBar,
  Badge,
  Collapse,
  Button,
  ListGroupItem,
  ListGroup,
  Spinner
} from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

const ActionsAnalista = ({
  sizeActions,
  countDraft,
  countApproval,
  countDisapproved,
  countAwaitingArts,
  countOnExecution,
  countAwaitingComprovations,
  countComprovationsApproval,
  countDisapprovedComprovations,
  countAwaitingReceipt,
  countFinished,
  countCancelled,
  loading
}) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  // console.log({
  //   sizeActions,
  //   countDraft,
  //   countApproval,
  //   countDisapproved,
  //   countAwaitingArts,
  //   countOnExecution,
  //   countAwaitingComprovations,
  //   countComprovationsApproval,
  //   countDisapprovedComprovations,
  //   countAwaitingReceipt,
  //   countFinished,
  //   countCancelled,
  //   loading
  // })

  const getValue = value => value ?? 0

  return (
    <Card className="shadow bg-white rounded mt-3 mb-3 card-style" style={{position:'relative'}}>
      <Card.Header>
        {t('label:actions')}
        <Button
          variant="light"
          size="sm"
          style={{ float: 'right' }}
          onClick={() => setOpen(!open)}
          aria-controls="example-collapse-text"
          aria-expanded={open}
          className={'btn-collapse'}
        >
          {' '}
          +
        </Button>
      </Card.Header>
      <Collapse in={open}>
        <Card.Body>
          <div className="mb-2">
            {t('statuses:draft')}
            <Badge variant="light" style={{ float: 'right' }}>
              {getValue(countDraft)}
            </Badge>
            <ProgressBar striped variant="warning" now={getValue(countDraft)} max={sizeActions}/>
          </div>

          <div className="mb-2">
            {t('statuses:on_approval')}
            <Badge variant="light" style={{ float: 'right' }}>
              {getValue(countApproval)}
            </Badge>
            <ProgressBar striped variant="warning" now={getValue(countApproval)} max={sizeActions}/>
          </div>

          <div className="mb-2">
            {t('statuses:disapproved')}
            <Badge variant="light" style={{ float: 'right' }}>
              {getValue(countDisapproved)}
            </Badge>
            <ProgressBar striped variant="warning" now={getValue(countDisapproved)} max={sizeActions}/>
          </div>

          <div className="mb-2">
            {t('statuses:awaiting_arts')}
            <Badge variant="light" style={{ float: 'right' }}>
              {getValue(countAwaitingArts)}
            </Badge>
            <ProgressBar striped variant="warning" now={getValue(countAwaitingArts)} max={sizeActions}/>
          </div>

          <div className="mb-2">
            {t('statuses:on_execution')}
            <Badge variant="light" style={{ float: 'right' }}>
              {getValue(countOnExecution)}
            </Badge>
            <ProgressBar striped variant="warning" now={getValue(countOnExecution)} max={sizeActions}/>
          </div>

          <div className="mb-2">
            {t('statuses:awaiting_comprovations')}
            <Badge variant="light" style={{ float: 'right' }}>
              {getValue(countAwaitingComprovations)}
            </Badge>
            <ProgressBar
              striped
              variant="warning"
              now={getValue(countAwaitingComprovations)} max={sizeActions}
            />
          </div>

          <div className="mb-2">
            {t('statuses:comprovations_approval')}
            <Badge variant="light" style={{ float: 'right' }}>
              {getValue(countComprovationsApproval)}
            </Badge>
            <ProgressBar
              striped
              variant="warning"
              now={getValue(countComprovationsApproval)} max={sizeActions}
            />
          </div>

          <div className="mb-2">
            {t('statuses:disapproved_comprovations')}
            <Badge variant="light" style={{ float: 'right' }}>
              {getValue(countDisapprovedComprovations)}
            </Badge>
            <ProgressBar
              striped
              variant="warning"
              now={getValue(countDisapprovedComprovations)} max={sizeActions}
            />
          </div>

          <div className="mb-2">
            {t('statuses:awaiting_receipt')}
            <Badge variant="light" style={{ float: 'right' }}>
              {getValue(countAwaitingReceipt)}
            </Badge>
            <ProgressBar striped variant="warning" now={getValue(countAwaitingReceipt)} max={sizeActions}/>
          </div>

          <div className="mb-2">
            {t('statuses:finished')}
            <Badge variant="light" style={{ float: 'right' }}>
              {getValue(countFinished)}
            </Badge>
            <ProgressBar striped variant="warning" now={getValue(countFinished)} max={sizeActions}/>
          </div>

          <div className="mb-2">
            {t('statuses:canceled')}
            <Badge variant="light" style={{ float: 'right' }}>
              {getValue(countCancelled)}
            </Badge>
            <ProgressBar striped variant="warning" now={getValue(countCancelled)} max={sizeActions}/>
          </div>
        </Card.Body>
      </Collapse>
      <ListGroup variant="flush">
        <ListGroupItem>
          <b>{t('label:total actions')}:</b> {!loading ? sizeActions : (<>
                  <Spinner animation="border" style={{ color: '#e05c17' }} size='sm' />
                </>)}
        </ListGroupItem>
      </ListGroup>
    </Card>
  );
};

export default ActionsAnalista;
